import { DISCORD_ICON_SVG, DISCORD_INVITE_URL } from "@site/config/discordConfig";
import { useLocale } from "@site/LocaleContext";
import styles from "@site/components/DiscordLink.module.css";

export function DiscordLink() {
  const { strings } = useLocale();

  return (
    <a
      className={styles.link}
      href={DISCORD_INVITE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="discord-link"
    >
      <span
        className={styles.icon}
        aria-hidden="true"
        dangerouslySetInnerHTML={{ __html: DISCORD_ICON_SVG }}
      />
      <span className={styles.label}>{strings.discordLinkLabel}</span>
    </a>
  );
}
